import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="m18 7-4-4H6c-.5 0-1 .5-1 1v15c0 .5.5 1 1 1h11c.5 0 1-.5 1-1V7zm-4-2.4L16.4 7H14V4.6zM17 19H6V4h7v4h4v11z"
      style={{
        fill: "#676767",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumFile);
export default Memo;
